import { render, staticRenderFns } from "./ImagePriority.vue?vue&type=template&id=78cb87df"
import script from "./ImagePriority.vue?vue&type=script&lang=js"
export * from "./ImagePriority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports